import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const LoaderContainer = styled.div`
  width: 30px;
  height: 30px;
  border: 4px solid #e5e5e5;
  border-top: 4px solid #0066ff;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const Loader = () => {
    return (
      <>
        <div style={{ padding: "2rem", display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
         <LoaderContainer>
          </LoaderContainer>
          <span>Loading...</span>
        </div>
      </>
    )
}